import DialPlansTable from 'pages/ga/dialPlans/new/DialPlansTable';
import DialPlanAdd from 'pages/ga/dialPlans/new/DialPlanAdd';
import DialPlanEdit from 'pages/ga/dialPlans/new/DialPlanEdit';
import RuleAdd from 'pages/ga/dialPlans/new/RuleAdd';
import RuleEdit from 'pages/ga/dialPlans/new/RuleEdit';

const DialPlansRoutes = [
    {
        index: true,
        element: <DialPlansTable />,
    },
    {
        path: 'add',
        element: <DialPlanAdd />,
    },
    {
        path: ':dialPlanId',
        element: <DialPlanEdit />,
    },
    {
        path: ':dialPlanId/rules/add',
        element: <RuleAdd />,
    },
    {
        path: ':dialPlanId/rules/:ruleId',
        element: <RuleEdit />,
    },
];

export default DialPlansRoutes;
